var moduleMap = {
	"./CodeQR": () => {
		return Promise.all([__webpack_require__.e(510), __webpack_require__.e(350), __webpack_require__.e(154), __webpack_require__.e(19), __webpack_require__.e(747), __webpack_require__.e(562), __webpack_require__.e(884), __webpack_require__.e(486), __webpack_require__.e(973), __webpack_require__.e(100), __webpack_require__.e(347), __webpack_require__.e(717)]).then(() => (() => ((__webpack_require__(46465)))));
	},
	"./Comments": () => {
		return Promise.all([__webpack_require__.e(510), __webpack_require__.e(350), __webpack_require__.e(154), __webpack_require__.e(584), __webpack_require__.e(884), __webpack_require__.e(486), __webpack_require__.e(973), __webpack_require__.e(100), __webpack_require__.e(347), __webpack_require__.e(351)]).then(() => (() => ((__webpack_require__(41476)))));
	},
	"./AuthProvider": () => {
		return Promise.all([__webpack_require__.e(154), __webpack_require__.e(884), __webpack_require__.e(973), __webpack_require__.e(974)]).then(() => (() => ((__webpack_require__(43809)))));
	},
	"./ActivityControl": () => {
		return Promise.all([__webpack_require__.e(154), __webpack_require__.e(79), __webpack_require__.e(884), __webpack_require__.e(973), __webpack_require__.e(100), __webpack_require__.e(574)]).then(() => (() => ((__webpack_require__(94574)))));
	},
	"./axiosInstance": () => {
		return Promise.all([__webpack_require__.e(154), __webpack_require__.e(884), __webpack_require__.e(973), __webpack_require__.e(974)]).then(() => (() => ((__webpack_require__(24974)))));
	}
};
var get = (module, getScope) => {
	__webpack_require__.R = getScope;
	getScope = (
		__webpack_require__.o(moduleMap, module)
			? moduleMap[module]()
			: Promise.resolve().then(() => {
				throw new Error('Module "' + module + '" does not exist in container.');
			})
	);
	__webpack_require__.R = undefined;
	return getScope;
};
var init = (shareScope, initScope) => {
	if (!__webpack_require__.S) return;
	var name = "default"
	var oldScope = __webpack_require__.S[name];
	if(oldScope && oldScope !== shareScope) throw new Error("Container initialization failed as it has already been initialized with a different share scope");
	__webpack_require__.S[name] = shareScope;
	return __webpack_require__.I(name, initScope);
};

// This exports getters to disallow modifications
__webpack_require__.d(exports, {
	get: () => (get),
	init: () => (init)
});